/* eslint-disable camelcase */

import { toString } from 'lodash-es';

/**
 * @mixin mixin/pagination
 * @desc 공통 mixin
 * @vue-data {String} uri=null - request uri
 * @vue-data {Object} params={} - request params
 * @vue-data {Function} callback=null - callback 함수
 * @vue-data {Number} maxPageCount=10 - 노출 가능한 갯수
 * @vue-data {Number} curPageIdx=0 -  페이지 넘버 0 이 1 페이지
 * @vue-data {Number} totalPageN=0 - 총 페이지 갯수
 * @vue-data {Array} listItems=null - 페이징 버튼 아이템
 * @vue-computed {Boolean} isFirst - 첫 페이지 인지 유무
 * @vue-computed {Boolean} isLast - 마지막 페이지 인지 유무
 * @vue-computed {Boolean} isCurrent - 현재 페이지 인지 유무
 * @vue-computed {Number} groupN - 페이지 그룹 넘버 (앞자리)
 * @vue-computed {Boolean} viewPageLength - for문 돌릴 길이 (10 혹은 잔여 숫자)
 * @vue-computed {Boolean} showPageLabel - 살제 pagination 을 이루는 페이지 넘버링
 */
export default {
  data() {
    return {
      uri         : null,
      params      : {},
      callback    : null,
      maxPageCount: 10, // 노출 가능한 갯수
      curPageIdx  : 0, // 페이지 넘버 0 이 1 페이지
      totalPageN  : 0, // 총 페이지 갯수
      listItems   : null
    };
  },
  computed: {
    isFirst() {
      return this.getGroup(this.curPageIdx) === this.getGroup(0);
    },
    isLast() {
      return (
        this.getGroup(this.curPageIdx) === this.getGroup(this.totalPageN - 1)
      );
    },
    isCurrent() {
      return (idx) => this.curPageIdx === idx + this.groupN;
    },
    // 페이지 그룹 넘버 (앞자리)
    groupN() {
      return (
        parseInt(this.$fo.force2Digits(this.curPageIdx).slice(0, -1)) *
        this.maxPageCount
      );
    },
    // for문 돌릴 길이 (10 혹은 잔여 숫자)
    viewPageLength() {
      if (!this.totalPageN) {
        return 0;
      }

      const currentFirst = this.$fo.force2Digits(this.curPageIdx).slice(0, -1);
      const targetFirst = this.totalPageN
        ? this.$fo.force2Digits(this.totalPageN).slice(0, -1)
        : null;

      // 현재 페이지와 총 페이지 맨뒷자리 제외하고 비교해 같으면 잔여 pagination 만 노출
      const len =
        currentFirst === targetFirst
          ? parseInt(toString(this.totalPageN).slice(-1)) || 0
          : this.maxPageCount;

      /* console.log(
        currentFirst,
        '==',
        targetFirst,
        'current',
        this.curPageIdx,
        'total',
        this.totalPageN,
        'result',
        len
      ); */

      console.log('viewPageLength : ', len);
      return len;
    },
    // 살제 pagination 을 이루는 페이지 넘버링
    showPageLabel() {
      return (idx) => {
        return idx + 1 + this.groupN;
      };
    }
  },
  watch: {
    curPageIdx(value) {
      this.loadPageData({
        params: {
          page_no: value + 1
          // page_no: value % 3 + 1 // xxx
        }
      });
    }
  },
  methods: {
    /**
     * @param {Object} params
     * @param {String} params.uri request uri
     * @param {Object} params.params request params
     * @param {Function} params.callback callback 함수
     */
    loadPageData({ uri, params, callback }) {
      if (!this.uri) {
        this.uri = uri;
      }

      if (params) {
        this.params = { ...this.params,
          ...params };
      }

      if (!this.callback) {
        this.callback = callback;
      }
   
      return this.axios
        .get(this.uri, {
          params: this.params
        })
        .then(this.callback || null)
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 페이지 변경
     * @param {Number} num
     */
    changePage(num) {
      // console.log(this.curPageIdx,' changePage == ', num);
      if (this.curPageIdx !== num) {
        this.curPageIdx = num;
      }
    },
    /**
     * 첫, 마지막 페이지 limit 체크 반환
     * @param {Number} n 체크할 페이지 넘버
     * @returns limit 체크된 페이지 넘버
     */
    checkPageLimit(n) {
      return Math.max(0, Math.min(n, this.totalPageN - 1));
    },
    /**
     * 이동할 페이지 그룹수 반환
     * @param {Number} n  이동할 페이지 넘버
     * @returns e.g getGroup(13) // 10
     */
    getGroup(n) {
      return (
        parseInt(this.$fo.force2Digits(n).slice(0, -1)) * this.maxPageCount
      );
    },
    /**
     * 다음 페이지 클릭 이벤트
     * @param {*} e
     */
    nextPage(e) {
      if (e.currentTarget.classList.contains('inactive')) {
        return;
      }

      const pageN = this.checkPageLimit(this.curPageIdx + this.maxPageCount);

      // 그룹 첫번째로
      this.changePage(this.getGroup(pageN));
    },
    /**
     * 이전 페이지 클릭 이벤트
     * @param {*} e
     */
    prevPage(e) {
      if (e.currentTarget.classList.contains('inactive')) {
        return;
      }

      const pageN = this.checkPageLimit(this.curPageIdx - this.maxPageCount);

      // 그룹 마지막으로
      this.changePage(this.getGroup(pageN) + this.maxPageCount - 1);
    },
    /**
     * 첫 페이지 클릭 이벤트
     * @param {*} e
     */
    firstPage(e) {
      if (e.currentTarget.classList.contains('inactive')) {
        return;
      }

      this.changePage(0);
    },
    /**
     * 마지막 페이지 클릭 이벤트
     * @param {*} e
     */
    lastPage(e) {
      if (e.currentTarget.classList.contains('inactive')) {
        return;
      }

      this.changePage(this.totalPageN - 1);
    }
  }
};
